import { HeaderLink, type HeaderLinkType } from '@app/shared/ui/molecules/Admin/Layout';

const LINKS: HeaderLinkType[] = ['balance', 'withdrawals', 'users', 'matrix-channel-form'];

export function AdminHeader() {
  return (
    <div className="mb-3 flex flex-wrap gap-2">
      {LINKS.map((link) => (
        <HeaderLink key={link} type={link} />
      ))}
    </div>
  );
}
